/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ProjectSummary,
  ProjectSummary$inboundSchema,
} from "./projectsummary.js";

/**
 * Result of user metrics summary query
 */
export type GetUserMetricsSummaryResult = {
  /**
   * Aggregated metrics
   */
  metrics: ProjectSummary;
};

/** @internal */
export const GetUserMetricsSummaryResult$inboundSchema: z.ZodMiniType<
  GetUserMetricsSummaryResult,
  unknown
> = z.object({
  metrics: ProjectSummary$inboundSchema,
});

export function getUserMetricsSummaryResultFromJSON(
  jsonString: string,
): SafeParseResult<GetUserMetricsSummaryResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetUserMetricsSummaryResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetUserMetricsSummaryResult' from JSON`,
  );
}
